export default (hostname, isMobile) => {
  const query = `${hostname}-${isMobile ? 'mweb' : 'web'}`
  const encodedSourceQuery = window.btoa(query)

  return `source=${encodedSourceQuery}`
}
